/*******************************************************************************
 * @ngdoc    object
 * @name     csm.books.data.BooksData.rws.type:Option
 * @constructor
 * @param {object=} option  Option info from server
 * @description
 * Remote webstore product option info.
 *******************************************************************************/
/* @ngInject */ export function RunOption(BooksData) {
  BooksData.rws.Option = function (option) {
    var rv = Object.assign(
      Object.create(BooksData.rws.Option.prototype),
      option || {}
    );
    rv.values = (rv.values || []).map(function (o) {
      return new BooksData.rws.OptionValue(o);
    });
    return rv;
  };

  BooksData.rws.Option.prototype = {
    subProductID: NaN, // Kit sub-product ID (kits only).
    name: null, // Option name.

    /*------------------------*/
    /* Input Only Properties. */
    /*------------------------*/
    value: null, // Selected value.

    /*-------------------------*/
    /* Output Only Properties. */
    /*-------------------------*/
    optional: false, // Optional Flag.
    values: [] // Possible option values.
  };
}
